import React from 'react';

import {
  StyledIcon,
  StyledIconContainer,
  StyledModal,
  StyledModalChildren,
  StyledModalContent,
  StyledTitle,
} from './styles';

import { CloseIcon } from '../Icons';

import type { ReactNode } from 'react';

interface ModalProps {
  children: ReactNode;
  show?: boolean;
  onClose: () => void;
  fullwidth?: boolean;
  title?: string;
}

export function Modal({ children, show = true, onClose, fullwidth, title }: ModalProps) {
  if (!show) {
    return null;
  }

  return (
    <StyledModal
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <StyledModalContent fullwidth={fullwidth}>
        <StyledIconContainer>
          <StyledIcon onClick={onClose}>
            <CloseIcon size="2xl" />
          </StyledIcon>
        </StyledIconContainer>
        {title && <StyledTitle>{title}</StyledTitle>}
        <StyledModalChildren>{children}</StyledModalChildren>
      </StyledModalContent>
    </StyledModal>
  );
}
